import { render, staticRenderFns } from "./siteAdminForm.vue?vue&type=template&id=336b3b44&scoped=true&"
import script from "./siteAdminForm.vue?vue&type=script&lang=babel&"
export * from "./siteAdminForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336b3b44",
  null
  
)

export default component.exports